import { render, staticRenderFns } from "./CommentsFromModel.vue?vue&type=template&id=0d73515b"
import script from "./CommentsFromModel.vue?vue&type=script&lang=js"
export * from "./CommentsFromModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports